import React from "react";
import HOC from "../../components/HOC";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import BreadcrumbRetur from "../../components/screen/Retur/BreadcrumbRetur";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";
import ReturSellPOS from "../../components/screen/Retur/ReturSellPOS";

const ReturSellPOSPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Retur Penjualan"
        mainComponent={
          <ThemeProvider theme={theme}>
            <ReturSellPOS />
          </ThemeProvider>
        }
        breadcrumb={<BreadcrumbRetur />}
        pageRole={47}
      />
    </div>
  );
};

export default HOC(ReturSellPOSPage);
